import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "d6aebfK8NNAzLAi6M1CcPzY", "AmnMove", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, tween, UITransform, v3, Node } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_AmnMoveType;

(function (E_AmnMoveType) {
  E_AmnMoveType[E_AmnMoveType["Normal"] = 0] = "Normal";
})(E_AmnMoveType || (E_AmnMoveType = {}));

var AmnMove = (_dec = menu("act/AmnMove"), _dec2 = property({
  type: Enum(E_AmnMoveType)
}), _dec3 = property({
  type: Node,
  tooltip: "目标节点 - 可以通过代码绑定"
}), _dec4 = property({
  visible: function visible() {
    return true;
  }
}), _dec5 = property({
  visible: function visible() {
    return true;
  }
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AmnMove, _Component);

  function AmnMove() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_to", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "angle", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "scale", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "speed", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "t", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "fixedTime", _descriptor7, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_callFunc", null);

    return _this;
  }

  var _proto = AmnMove.prototype;

  // LIFE-CYCLE CALLBACKS:
  // onLoad () {}
  _proto.start = function start() {}
  /**目标节点 */
  ;

  _proto.to_Node = function to_Node(n_to) {
    this.n_to = n_to;
  }
  /**动作完成后 - 回调 */
  ;

  _proto.callFunc = function callFunc(calFunc) {
    this._callFunc = calFunc;
  };

  _proto.act = function act() {
    switch (this.type) {
      case E_AmnMoveType.Normal:
        this.handle_normal();
        break;
    }
  };

  _proto.reset = function reset() {
    this.scale = 0;
    this.angle = 0;
  };

  _proto.handle_normal = function handle_normal() {
    var _this2 = this;

    var c_w = this.node.getComponent(UITransform).convertToWorldSpaceAR(v3(0, 0, 0));
    var a_w = this.n_to.getComponent(UITransform).convertToWorldSpaceAR(v3(0, 0, 0));
    var deltaPos = a_w.subtract(c_w);
    var t = 0;

    if (this.fixedTime) {
      t = this.t;
    } else {
      var mag = deltaPos.length();
      t = mag / this.speed;
    }

    tween(this.node).by(t, {
      position: v3(deltaPos.x, deltaPos.y),
      scale: v3(this.scale, this.scale),
      angle: this.angle
    }).call(function () {
      if (_this2._callFunc) {
        _this2._callFunc();
      }
    }).start();
  } // update (dt) {}
  ;

  return AmnMove;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_AmnMoveType.Normal;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_to", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "angle", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "scale", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "speed", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 800;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "t", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0.5;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "fixedTime", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class);
export { AmnMove as default };

_cclegacy._RF.pop();